import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Provisional", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Job")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Client", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Inspector")
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Time")
], -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Inspector")
], -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Appointment time")
], -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 6,
  class: "mt-4"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Property")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "mr-4"
}
const _hoisted_30 = {
  key: 1,
  class: "mr-4"
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = {
  key: 7,
  class: "mt-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Booked by:")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Access", -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Release", -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { key: 4 }
const _hoisted_44 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Tenants", -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { key: 3 }
const _hoisted_50 = { key: 4 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Landlord", -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = {
  key: 8,
  class: "mt-4"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Notes", -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { key: 9 }
const _hoisted_61 = { key: 10 }
const _hoisted_62 = { key: 11 }
const _hoisted_63 = { key: 12 }
const _hoisted_64 = { key: 13 }
const _hoisted_65 = { key: 14 }
const _hoisted_66 = { key: 15 }
const _hoisted_67 = { key: 16 }
const _hoisted_68 = { key: 17 }
const _hoisted_69 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Cost", -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 2 }

import { computed, PropType, inject } from 'vue';
import _get from 'lodash/get';
import moment from 'moment-timezone';
import { useStore } from 'vuex';
import { Bookedby, Booking, Landlord, Tenant, Report } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingDetail',
  props: {
  booking: { type: Booking },
  leadbooking: { type: Booking },
  prepandkeybookings: Array as PropType<Booking[]>,
},
  setup(__props) {

const actProperty: any = inject('actProperty');

const props = __props;
const store = useStore();
const cognitoUser = computed(() => store.getters['auth/cognitoUser']);
const dictionary = computed(() => store.getters['dictionary/current']);
const internaljobtypedisplayname = computed((): Map<string, string> => store.getters['diary/internaljobtypedisplayname']);
const isDiaryUser = computed(() => {
  const assignedGroups = _get(cognitoUser.value, 'signInUserSession.accessToken.payload["cognito:groups"]', []);
  return assignedGroups.some((group: string) => group === "DiaryUser");
});
const pischeduler = computed(() => screen.width <= 760 && isDiaryUser.value);

function onAddressclick() {
  if (pischeduler.value) {
    const address = actProperty.formatAddress(props.leadbooking?.address, ", ");
    window.open(`http://maps.google.com/?q=${encodeURIComponent(address)}`, '_blank', 'noreferrer');
  }
}

const propertyspec = computed(() => {
  let lines = [];
  const spec = props.leadbooking?.propertyspec;
  if (spec?.bedrooms) lines.push(`${spec.bedrooms} bedrooms`);
  if (spec?.bathrooms) lines.push(`${spec.bathrooms} bathrooms`);
  if (spec?.receptions) lines.push(`${spec.receptions} receptions`);
  if (spec?.other) lines.push(`${spec?.other} other`);
  return lines.join(", ");
});

const appointmenttime = computed(() => {
  let apptime = moment(props.booking?.appointmenttime).utc().format("h:mm a");
  if (apptime === "12:00 am") return "No Tenant but Fixed Time";
  if (apptime === "12:15 am") return "Flexi all day";
  if (apptime === "12:20 am") return "Flexi AM";
  if (apptime === "12:25 am") return "Flexi PM";
  return apptime;
});

const access = computed(() => {
  var response = "";
  switch (props.leadbooking?.keypickup) {
    case "From Agency":
      response =
        "Access via Agency - " +
        props.leadbooking?.customer?.companyName + ' - ' + props.leadbooking?.keypickupbranchname + " (" +
        actProperty.formatAddress(props.leadbooking?.keypickupfromaddress, ", ") +
        ")";
      break;
    case "Meet Tenant":
      if (props.leadbooking?.tenantattending === 'no') {
        response = release.value;
      }
      else {
        response = "Meeting tenant at the property";
      }
      response = `${response} - ${actProperty.formatAddress(props.leadbooking?.keypickupfromaddress, ", ")}`;
      break;
    case "Via Concierge":
      response = `Via Concierge - ${actProperty.formatAddress(props.leadbooking?.keypickupfromaddress, ", ")}`;
      break;
    case "Via Landlord":
      response = `Meeting landlord at the property - ${actProperty.formatAddress(props.leadbooking?.keypickupfromaddress, ", ")}`;
      break;
    case "TBC":
      response = props.leadbooking?.confirmaccess ? "Confirmed" : "To be confirmed";
      response = `${response} - ${actProperty.formatAddress(props.leadbooking?.keypickupfromaddress, ", ")}`;
      break;
    case "Misc":
      response = `Misc - ${actProperty.formatAddress(props.leadbooking?.keypickupfromaddress, ", ")}`;
      break;
    default:
      response = "To be confirmed";
      break;
  }
  return response;
});

const release = computed(() => {
  var response = "";
  switch (props.booking?.releasekeysto) {
    case "To Agency":
      response =
        "Keys released to branch (" +
        actProperty.formatAddress(props.leadbooking?.keyreleasetoaddress, ", ") +
        ")";
      break;
    case "Meet Tenant":
      response = "Meeting tenant at the property";
      response = `${response} - ${actProperty.formatAddress(props.leadbooking?.keyreleasetoaddress, ", ")}`;
      break;
    case "Via Concierge":
      response = `Via Concierge - ${actProperty.formatAddress(props.leadbooking?.keyreleasetoaddress, ", ")}`;
      break;
    case "Via Landlord":
      response = `Meeting landlord at the property - ${actProperty.formatAddress(props.leadbooking?.keyreleasetoaddress, ", ")}`;
      break;
    case "TBC":
      response = props.leadbooking?.confirmaccess ? "Confirmed" : "To be confirmed";
      response = `${response} - ${actProperty.formatAddress(props.leadbooking?.keyreleasetoaddress, ", ")}`;
      break;
    case "Misc":
      response = `Misc - ${actProperty.formatAddress(props.leadbooking?.keyreleasetoaddress, ", ")}`;
      break;
    default:
      response = "To be confirmed";
      break;
  }
  return response;
});

const keytobereleased = computed(() => {
  var response = "";
  switch (props.booking?.keystobereleased) {
    case "Yes":
      response =
        "Keys to be released ";
      break;
    case "No":
      response = "Keys are not released";
      break;
    case "TBC":
      response = "Key release To be confirmed";
      break;
  }
  return response;
});

const accesstbc = computed(() => {
  var response = '';
  if (props.leadbooking?.keypickup === 'Meet Tenant' && props.leadbooking.tenantattending != 'yes' && props.leadbooking.tenantattending != 'no') {
    response = ' - TBC';
  }
  else if (!props.leadbooking?.confirmaccess) {
    response = ' - TBC';
  }
  else {
    response = ' - confirmed';
  }
  return response;
})

const masterReportType = computed(() => {
  return actProperty.formatReportType(props.booking.leadbooking?.jobtype, dictionary)
});


function getTenantdetails(tenant: Tenant) {
  let lines: string[] = [];
  if (tenant.ttname) lines.push(`${tenant.ttname}`);
  if (tenant.ttemail) lines.push(`Email: ${tenant.ttemail}`);
  if (tenant.ttmobile) lines.push(`Mobile: ${tenant.ttmobile}`);
  return lines.join(", ");
}

function getBookedbydetails(bookedby: Bookedby) {
  let lines: string[] = [];
  if (bookedby.bbname) lines.push(`${bookedby.bbname}`);
  if (bookedby.bbemail) lines.push(`Email: ${bookedby.bbemail}`);
  if (bookedby.bbmobile) lines.push(`Mobile: ${bookedby.bbmobile}`);
  return lines.join(", ");
}

function getLandlorddetails(landlord: Landlord) {
  let lines: string[] = [];
  if (landlord.llname) lines.push(`${landlord.llname}`);
  if (landlord.llemail) lines.push(`Email: ${landlord.llemail}`);
  if (landlord.llmobile) lines.push(`Mobile: ${landlord.llmobile}`);
  return lines.join(", ");
}

const cost = computed(() => {
  return props.leadbooking?.invoices.reduce((sum: number, invoice: Report) => sum + invoice.totalFees(), 0)
});

const worksorder = computed(() => {
  return props.leadbooking?.worksorder;
});

const customLabelForInternaljobtype = (internaljobtype: string): string => {
  return actProperty.customLabelForInternaljobtype(internaljobtypedisplayname.value, internaljobtype)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.leadbooking?.provisional)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (__props.leadbooking?.provisional)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Why: " + _toDisplayString(__props.leadbooking.provisionalnotes), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("h3", {
        class: "mb-0",
        onClick: onAddressclick
      }, "Address")
    ]),
    _createElementVNode("div", { onClick: onAddressclick }, _toDisplayString(_unref(actProperty).formatAddress(__props.leadbooking?.address, ", ")), 1),
    _createElementVNode("div", null, [
      _hoisted_5,
      _createElementVNode("div", null, _toDisplayString(_unref(actProperty).formatReportType(__props.leadbooking?.jobtype, dictionary.value)) + " / " + _toDisplayString(customLabelForInternaljobtype(__props.leadbooking?.internaljobtype)), 1)
    ]),
    _createElementVNode("div", null, [
      (__props.booking?.customer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      (__props.booking?.customer &&
      (__props.booking.customer.companyName || __props.booking.customer.branchName)
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.booking.customer.companyName) + " - " + _toDisplayString(__props.booking.customer.branchName), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.booking.subtype != 'Prep')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          (__props.booking?.inspector)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(__props.booking.inspector.name) + " ", 1),
                (__props.prepandkeybookings?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.prepandkeybookings, (prepdata, $prepdata) => {
                        return (_openBlock(), _createElementBlock("div", { key: $prepdata }, [
                          (prepdata?.inspector.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(prepdata.inspector.name) + " - (" + _toDisplayString(prepdata.subtype) + ") ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_15,
    (__props.booking?.startdate || __props.booking?.enddate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(__props.booking.starttime) + " to " + _toDisplayString(__props.booking.endtime), 1))
      : _createCommentVNode("", true),
    (__props.booking.subtype === 'Prep')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (__props.booking?.leadbooking?.startdate || __props.booking.leadbooking?.enddate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(__props.booking?.leadbooking?.bookingdate) + " - " + _toDisplayString(__props.booking?.leadbooking?.starttime) + " to " + _toDisplayString(__props.booking?.leadbooking?.endtime) + " - (" + _toDisplayString(masterReportType.value) + ") ", 1))
            : _createCommentVNode("", true),
          _hoisted_19,
          (__props.booking.inspector)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(__props.booking.inspector.name), 1))
            : _createCommentVNode("", true),
          (__props.booking?.leadbooking)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(__props.booking?.leadbooking?.inspector.name) + " - (" + _toDisplayString(masterReportType.value) + ") ", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.prepandkeybookings?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.prepandkeybookings, (prepdata, $prepdata) => {
            return (_openBlock(), _createElementBlock("div", { key: $prepdata }, [
              (prepdata?.startdate || prepdata?.enddate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(prepdata.bookingdate) + " - " + _toDisplayString(prepdata.starttime) + " to " + _toDisplayString(prepdata.endtime) + " - (" + _toDisplayString(prepdata.subtype) + ") ", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_24,
      (__props.booking?.appointmenttime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(appointmenttime.value), 1))
        : _createCommentVNode("", true),
      (appointmenttime.value === 'No Tenant but Fixed Time' && __props.booking?.fixedtimenotes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Fixed time notes: " + _toDisplayString(__props.booking.fixedtimenotes), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.leadbooking?.propertyspec)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", null, [
            (__props.leadbooking.propertyspec.propertytype)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Property type: " + _toDisplayString(__props.leadbooking.propertyspec.propertytype), 1))
              : _createCommentVNode("", true),
            (__props.leadbooking.propertyspec.furnished)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Furnished: " + _toDisplayString(__props.leadbooking.propertyspec.furnished), 1))
              : _createCommentVNode("", true),
            (propertyspec.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(propertyspec.value), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.leadbooking?.bookedbypresent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _hoisted_33,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leadbooking.bookedby, (bookedby, $bookedbyindex) => {
            return (_openBlock(), _createElementBlock("div", { key: $bookedbyindex }, [
              _createElementVNode("span", null, _toDisplayString(getBookedbydetails(bookedby)), 1),
              _hoisted_34
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (__props.leadbooking?.keypickup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
        : _createCommentVNode("", true),
      (__props.leadbooking?.keypickup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createTextVNode(_toDisplayString(access.value), 1),
            _createElementVNode("span", null, _toDisplayString(accesstbc.value), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.leadbooking?.releasekeysto)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
        : _createCommentVNode("", true),
      (__props.leadbooking?.keystobereleased)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(keytobereleased.value), 1))
        : _createCommentVNode("", true),
      (__props.leadbooking?.releasekeysto)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(release.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (__props.leadbooking?.keypickup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
        : _createCommentVNode("", true),
      (__props.leadbooking?.tenantattending === 'yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Are tenants attending - Yes "))
        : (__props.leadbooking?.tenantattending === 'no')
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Are tenants attending - No "))
          : (_openBlock(), _createElementBlock("div", _hoisted_49, "Are tenants attending - TBC")),
      (__props.leadbooking?.tenants.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leadbooking.tenants, (tenant, $tenantindex) => {
              return (_openBlock(), _createElementBlock("div", { key: $tenantindex }, [
                _createElementVNode("span", null, _toDisplayString(getTenantdetails(tenant)), 1),
                _hoisted_51
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (__props.leadbooking?.landlordpresent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
        : _createCommentVNode("", true),
      (__props.leadbooking?.landlordpresent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leadbooking.landlords, (landlord, $landlordindex) => {
              return (_openBlock(), _createElementBlock("div", { key: $landlordindex }, [
                _createElementVNode("span", null, _toDisplayString(getLandlorddetails(landlord)), 1),
                _hoisted_56
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.leadbooking?.internalnotes || __props.leadbooking?.clientnotes || __props.booking?.pinotes || __props.booking?.accessissues)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
      : _createCommentVNode("", true),
    (__props.leadbooking.id != __props.booking.id && __props.leadbooking?.accessissues)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, " Master access notes: " + _toDisplayString(__props.leadbooking.accessissues), 1))
      : _createCommentVNode("", true),
    (__props.booking?.accessissues)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, " Access notes: " + _toDisplayString(__props.booking.accessissues), 1))
      : _createCommentVNode("", true),
    (__props.booking?.pinotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_62, " PI notes: " + _toDisplayString(__props.booking.pinotes), 1))
      : _createCommentVNode("", true),
    (__props.leadbooking.id != __props.booking.id && __props.leadbooking?.pinotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_63, " Master PI notes: " + _toDisplayString(__props.leadbooking.pinotes), 1))
      : _createCommentVNode("", true),
    (__props.leadbooking?.internalnotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, " ACT office notes: " + _toDisplayString(__props.leadbooking.internalnotes), 1))
      : _createCommentVNode("", true),
    (__props.leadbooking?.clientnotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_65, " Client notes: " + _toDisplayString(__props.leadbooking?.clientnotes), 1))
      : _createCommentVNode("", true),
    (__props.leadbooking?.titlenotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, " Title notes: " + _toDisplayString(__props.leadbooking.titlenotes), 1))
      : _createCommentVNode("", true),
    (__props.leadbooking?.longtermnotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, " Long term notes: " + _toDisplayString(__props.leadbooking.longtermnotes), 1))
      : _createCommentVNode("", true),
    (!pischeduler.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
          ((cost.value || worksorder.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71))
            : _createCommentVNode("", true),
          (cost.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, "Cost: " + _toDisplayString(_unref(actProperty).formatCurrency(cost.value)), 1))
            : _createCommentVNode("", true),
          (worksorder.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, "Worksorder: " + _toDisplayString(worksorder.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})